import React, { SVGProps } from 'react'
const SvgCard = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox={'0 0 24 24'}
    aria-hidden="true"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M18.946 10H6.054C5.473 10 5 10.344 5 10.767v6.466c0 .423.473.767 1.054.767h12.892c.581 0 1.054-.344 1.054-.767v-6.466c0-.423-.473-.767-1.054-.767Z" />
      <path
        fill={props.fill || 'var(--color-cta)'}
        fillRule="nonzero"
        d="M18.946 6.5H6.054c-.857 0-1.554.697-1.554 1.554v8.892c0 .857.697 1.554 1.554 1.554h12.892c.857 0 1.554-.697 1.554-1.554V8.054c0-.857-.697-1.554-1.554-1.554Zm-12.892 1h12.892c.305 0 .554.25.554.554v8.892c0 .305-.25.554-.554.554H6.054a.556.556 0 0 1-.554-.554V8.054c0-.305.25-.554.554-.554Z"
      />
      <path
        fill={props.fill || 'var(--color-cta)'}
        fillRule="nonzero"
        d="M18.946 6.5H6.054c-.857 0-1.554.697-1.554 1.554V11h16V8.054c0-.857-.697-1.554-1.554-1.554Zm0 1 .09.007a.556.556 0 0 1 .464.547V10h-14V8.054c0-.305.25-.554.554-.554h12.892ZM17.25 14.5a.5.5 0 0 1 .09.992l-.09.008H14.5a.5.5 0 0 1-.09-.992l.09-.008h2.75Z"
      />
    </g>
  </svg>
)
export default SvgCard
